module.exports = __webpack_public_path__ + "static/media/logo_loship.648cf96a.png";